document.addEventListener("DOMContentLoaded", function() {
    let contentBlocks = document.querySelectorAll('.abstract--uk .career-benifits-block__inner-container');
    contentBlocks.forEach(block => {
        block.style.display = 'none';
    });

    let sidebarLinks = document.querySelectorAll('.abstract--uk .career-benifits-block__sidebar-title-inner');
    if (sidebarLinks.length > 0) {
        let firstTarget = sidebarLinks[0].getAttribute('data-target');
        if (firstTarget) {
            document.querySelector(firstTarget).style.display = 'grid';
        }
    }

    let firstActiveLi = document.querySelector('.abstract--uk .career-benifits-block__sidebar-title.active');
    if (firstActiveLi) {
        firstActiveLi.style.backgroundColor = '#B6ECE3';
    }

    sidebarLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();

            updateActiveClass(e.currentTarget);

            contentBlocks.forEach(block => {
                block.style.display = 'none';
            });
            let targetContentId = e.currentTarget.getAttribute('data-target');
            if (targetContentId) {
                document.querySelector(targetContentId).style.display = 'grid';
            }
        });
    });


    function updateActiveClass(clickedLink) {
        document.querySelectorAll('.career-benifits-block__sidebar-title').forEach(li => {
            li.classList.remove('active');
            li.style.backgroundColor = '';
        });
        
        let parentLi = clickedLink.closest('.career-benifits-block__sidebar-title');
        parentLi.classList.add('active');
        parentLi.style.backgroundColor = '#B6ECE3';
    }
});